import { Icon } from "../../icons";
import type { InteractiveItem } from "./items";

interface MenuRowContentProps {
  item: InteractiveItem;
  /** Id of the hidden disabled reason, referenced by the row's `aria-describedby`. */
  reasonId: string;
}

/** What a row shows, in order: checkbox, swatch, icon, label, hint, radio check, submenu chevron. */
export function MenuRowContent({ item, reasonId }: MenuRowContentProps): React.JSX.Element {
  return (
    <>
      {item.kind === "checkbox" ? (
        <span className={`nb-ctx-box${item.checked ? " is-on" : ""}`} aria-hidden="true">
          {item.checked ? <Icon name="check" /> : null}
        </span>
      ) : null}
      {item.swatch ? <span className="nb-ctx-swatch" style={{ background: item.swatch }} aria-hidden="true" /> : null}
      {item.icon ? <Icon name={item.icon} aria-hidden="true" /> : null}
      <span className="nb-ctx-label">{item.label}</span>
      {item.hint ? <span className="nb-menu-item-trail">{item.hint}</span> : null}
      {item.kind === "radio" ? <Icon name="check" className="nb-menu-check" aria-hidden="true" /> : null}
      {item.kind === "submenu" ? <Icon name="chevronRight" className="nb-ctx-chevron" aria-hidden="true" /> : null}
      {item.disabledReason ? (
        <span id={reasonId} className="nb-sr" aria-hidden="true">
          {item.disabledReason}
        </span>
      ) : null}
    </>
  );
}
